import { useTranslation } from "react-i18next";
import { Button } from "@tellescope/design-system";
import { FilterBlockEditor, Popover, PopoverContent, PopoverTrigger } from "@tellescope/ui";
import { type FreeformFieldOption, type FreeformFilterBlock } from "@tellescope/utils";
import { ListFilter } from "lucide-react";
import { CalendarFilterValueInput } from "./CalendarFilterValueInput";

export interface CalendarFilterPopoverProps {
  filterBlock: FreeformFilterBlock;
  fieldOptions: FreeformFieldOption[];
  onFilterChange: (block: FreeformFilterBlock) => void;
}

/**
 * Fields `CalendarFilterValueInput` handles. Other fields must fall through to
 * `FilterConditionRow`'s built-in inputs, which only happens when `renderValueInput` returns
 * `undefined` — so membership is checked here rather than inside the component.
 */
const CUSTOM_VALUE_INPUT_FIELDS = ["templateId", "locationId", "attendees"];

export const CalendarFilterPopover = ({ filterBlock, fieldOptions, onFilterChange }: CalendarFilterPopoverProps) => {
  const { t } = useTranslation("contacts");

  return (
    <Popover>
      <PopoverTrigger asChild>
        <Button iconOnly variant="ghost" size="sm" color="muted" hoverLabel={t("Filter appointments")}>
          <ListFilter />
        </Button>
      </PopoverTrigger>
      <PopoverContent className="w-96 p-2" align="end">
        <FilterBlockEditor
          block={filterBlock}
          fieldOptions={fieldOptions}
          onChange={onFilterChange}
          onRemove={() => onFilterChange({ ...filterBlock, filters: [] })}
          renderValueInput={({ filter, onChange }) =>
            CUSTOM_VALUE_INPUT_FIELDS.includes(filter.field) ? (
              <CalendarFilterValueInput filter={filter} onChange={onChange} />
            ) : undefined
          }
        />
      </PopoverContent>
    </Popover>
  );
};
